import { useTheme } from "@mui/material/styles";

const drawerWidth = 240;

export const useNavStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: "flex",
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: "none",
    },
    title: {
      flexGrow: 1,
      marginRight: theme.spacing(5),
      paddingTop: theme.spacing(0.5),
    },
    drawerPaper: {
      display: "flex",
      flexDirection: "column" as const,
      position: "relative" as const,
      whiteSpace: "nowrap" as const,
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: "hidden" as const,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column" as const,
    },
    fixedHeight: {
      height: 240,
    },
    navBarColor: {
      background: "#1E0078",
    },
    navBarSecondaryColor: {
      background: theme.palette.error.dark,
    },
    envDisplayText: {
      color: "#FFF",
      paddingTop: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginLeft: theme.spacing(1.25),
    },
    versionDisplay: {
      fontSize: 12,
      paddingRight: 52,
    },
    topNavLogo: {
      paddingTop: theme.spacing(1.5),
    },
  };
};

// For backward compatibility
const navStyles = useNavStyles;
export default navStyles;
